export function commercialStockRequest(state = {
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "CREATE_COMMERCIAL_STOCK_START":           
        case "FETCH_COMMERCIAL_STOCKS_START":           
        case "DELETE_COMMERCIAL_STOCK_START":           
            return {
                ...state, 
                fetching:true
            }        
        case "CREATE_COMMERCIAL_STOCK_FULFILLED":           
        case "FETCH_COMMERCIAL_STOCKS_FULFILLED":           
        case "DELETE_COMMERCIAL_STOCK_FULFILLED":           
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "CREATE_COMMERCIAL_STOCK_ERROR":
        case "FETCH_COMMERCIAL_STOCKS_ERROR":
        case "DELETE_COMMERCIAL_STOCK_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}